<template>
  <div class="vipcardpage">
    <div class="vipcardcenter">
      <div class="vipcardbox"  @click="openpopup">

        <div class="cardbox2" v-if="isback">
          <div class="cardnumber"  v-if="carddetail.status==10">{{ carddetail.car_no ? carddetail.car_no : '' }}</div>
          <div class="cardtypename" v-if="carddetail.status==10">到期时间：{{ carddetail.overdue_at ? carddetail.overdue_at : '' }}</div>
<!--          <div class="card-price" v-if="carddetail.status==10">已优惠360元</div>-->
          <div class="cardnumber"  v-if="carddetail.status==1">No:0000001</div>
        </div>
      </div>
      <div class="vipcardnone"></div>


      <div class="vipcarddetaillist">
        <div class="vipcarddetailbox" v-for="(item,index) in carddetail.info.items" :key="item.id" @click="toservice(item.product_id,item.id)">
          <img class="vipcarddetailicon" :src="item.thumb" />
          <div class="vipcarddetailname">{{item.name}}</div>
        </div>
      </div>
      <!--   <img class="vipcarddetaillabel" /> -->
<!--      <div v-if="status==1" class="vipcardbotton" >立即续费￥<span style="font-size: 23px;">99</span>元/年</div>-->
<!--      <div class="vipcardbotton">立即购买￥<span style="font-size: 23px;">99</span>元/年</div>-->
<!--      <div  v-if="usertype=='0'"  class="vipcardbotton1">暂未开放</div>-->
      <div  class="vipcardbotton" v-if="carddetail.status==1" @click="activation">立即激活</div>
      <div class="vipcardselectbox" v-if="carddetail.status==1" @click="changeisagree">
        <img class="vipcardcheckicon" :src="isagree ? '../../../static/yixuancard.png' : '../../../static/weixuancard.png'" />
        <div class="vipcardchecktext">阅读并同意<span @click="tovippricacy" style="color: #FD0303;">《优越服务车主卡协议》</span></div>
      </div>
    </div>
<!--    权益弹框-->
    <van-popup v-model="show" closeable position="bottom" :style="{ height: '70%' }">
        <div class="quanyititle">权益规则</div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">洗车7折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.车主卡会员标准洗车服务可享受7折优惠，(不包含精致洗车服务)。优越服务内带有“车主卡会员”标签的洗车服务商品享受折扣（无标签服务不享受折扣），具体折扣以下单时的优惠为准。</div>
        <div class="quanyidetail">2.权益可在优越服务公众号下单时使用，一张卡只能绑定一辆车牌使用权益。</div>
        <div class="quanyidetail">3.权益限在优越服务门店上架洗车服务的门店使用，部分门店除外。</div>
        <div class="quanyidetail">使用方式:</div>
        <div class="quanyidetail">进入优越服务公众号，选择您需要的门店相关服务下单支付，在会员折扣范围内的项目/服务均可享受会员折扣。会员折扣可与其他优惠券叠加使用；订单支付完成后需前往下单门店核销订单，由技师进行服务。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">打蜡7折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.车主卡会员普通打蜡服务（含洗车）可享受7折优惠，(不包含抛光打蜡服务)。优越服务内带有“车主卡会员”标签的打蜡服务商品享受折扣（无标签服务不享受折扣），具体折扣以下单时的优惠为准。</div>
        <div class="quanyidetail">2.权益可在优越服务公众号下单时使用，一张卡只能绑定一辆车牌使用权益。</div>
        <div class="quanyidetail">3.权益限在优越服务门店上架相关服务的门店使用，部分门店除外。</div>
        <div class="quanyidetail">使用方式:</div>
        <div class="quanyidetail">进入优越服务公众号，选择您需要的门店打蜡服务下单支付，在会员折扣范围内的项目/服务均可享受会员折扣。会员折扣可与其他优惠券叠加使用；订单支付完成后需前往下单门店核销订单，由技师进行服务。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">消毒7折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.车主卡会员车内消毒服务（含洗车）可享受7折优惠。优越服务内带有“车主卡会员”标签的车内消毒服务商品享受折扣（无标签服务不享受折扣），具体折扣以下单时的优惠为准。</div>
        <div class="quanyidetail">2.权益可在优越服务公众号下单时使用，一张卡只能绑定一辆车牌使用权益。</div>
        <div class="quanyidetail">3.权益限在优越服务门店上架相关服务的门店使用，部分门店除外。</div>
        <div class="quanyidetail">使用方式:</div>
        <div class="quanyidetail">进入优越服务公众号，选择您需要的门店车内消毒服务下单支付，在会员折扣范围内的项目/服务均可享受会员折扣。会员折扣可与其他优惠券叠加使用；订单支付完成后需前往下单门店核销订单，由技师进行服务。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">补胎7折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.会员有效期内，您爱车的轮胎若产生漏气、扎钉或需要补气的情况，均可到店进行8折补胎或免费轮胎补气服务，权益不限使用次数。</div>
        <div class="quanyidetail">2.补胎仅限门店为普通轮胎提供的贴片补胎服务，若您爱车的轮胎是防爆胎/静音棉胎等特殊轮胎，需补工时费用差价；另外补胎服务包含动平衡。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">保养8折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.保养类部分商品可享受8折起优惠，具体保养折扣商品开通会员后在优越服务见带有“车主卡会员”标签产品。</div>
        <div class="quanyidetail">2.折扣权益可与优惠券叠加使用，使用优惠券后的金额再叠加8折优惠，具体以确认订单页显示的优惠为准。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">喷漆8折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.喷漆类部分商品可享受8折起优惠（不含特殊车漆），具体喷漆折扣商品开通会员后在优越服务见带有“车主卡会员”标签产品。</div>
        <div class="quanyidetail">2.折扣权益可与优惠券叠加使用，使用优惠券后的金额再叠加8折优惠，具体以确认订单页显示的优惠为准。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">空调清洗8折</div>
        <div class="quanyidetail">权益介绍:</div>
        <div class="quanyidetail">1.车主卡会员空调清洗服务（含洗车）可享受8折优惠。优越服务内带有“车主卡会员”标签的空调清洗服务商品享受折扣（无标签服务不享受折扣），具体折扣以下单时的优惠为准。</div>
        <div class="quanyidetail">2.权益可在优越服务公众号下单时使用，一张卡只能绑定一辆车牌使用权益。</div>
        <div class="quanyidetail">3.权益限在优越服务门店上架相关服务的门店使用，部分门店除外。</div>
        <div class="quanyidetail">使用方式:</div>
        <div class="quanyidetail">进入优越服务公众号，选择您需要的门店车内空调清洗下单支付，在会员折扣范围内的项目/服务均可享受会员折扣。会员折扣可与其他优惠券叠加使用；订单支付完成后需前往下单门店核销订单，由技师进行服务。</div>
      </div>

      <div class="quanyidetailbox">
        <div class="quanyidetailtitle">保险增值服务权益使用专属顾问</div>
        <div class="quanyidetail">1.可在周一至日，8：30－18：00，线上或电话专属顾问为你解答保险增值服务（道路非事故救援、代驾、代为送检、安全检测）等权益使用问题。</div>
      </div>
      <div class="quanyidetailbox">
        <div class="vipcardtiptitle"><span style="font-size: 23px;">8</span>大专属权益 多家门店使用</div>
        <div class="quanyidetail">1.车主卡在优越服务全省1000多家门店使用，中山门店近200家；</div>
        <div class="quanyidetail">2.每位购买成功的用户只能绑定一个车牌号码使用,不便之处，敬请谅解；</div>
        <div class="quanyidetail">3.如有疑问请联系客服中心：400-893-2218；</div>
        <div class="quanyidetail">*最终解释权归广东优越车网信息科技有限公司所有；</div>
      </div>
    </van-popup>
<!--    激活弹窗-->
    <van-popup v-model="activationpopup" style="width: calc(100% - 80px);
    border-radius: 10px;">
      <div class="activationbox">
        <div class="activationboxtitle">激活</div>
        <div class="activationinputbox">
          <div class="activationinputtext">车牌号：</div>
          <input type="text" class="activationinput" v-model="cardNo" placeholder="请输入车牌号" />
        </div>
        <div class="activationbotton" @click="buttonClicked ? '' : confirm()" >确认激活</div>
      </div>
    </van-popup>
    <!-- <marquee>
      <ul class="fa-scroll-cont">
        <li v-for="item in realData" :key="item.name">
          <span class="roll-text">{{ item.name }}</span>
        </li>
      </ul>
    </marquee> -->
    <div class="marqueecontainer" v-if="usertype!='0'">
      <div class="vague">
        <div class="logoMove">
          <div class="logo1">
            <div class="marqueebox" v-for="(item,index) in realData">
              <img :src="item.url" class="marqueeimg">
              <div class="marqueename">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="vipcardstorelist">-->
<!--        <div class="vipcardstoretop" @click="toservice">-->
<!--          <div class="vipcardstoremore">查看适合门店</div>-->
<!--          <div class="vipcardstoreall">-->
<!--&lt;!&ndash;            <div class="vipcardstoremore">全部</div>&ndash;&gt;-->
<!--            <img src="../../../static/xiangyou.png" class="vipcardstoreallicon" />-->
<!--          </div>-->
<!--        </div>-->
<!--      <div class="vipcardstore">-->
<!--        <img src="../../../static/cardzheng.png" class="vipstoreimg" />-->
<!--        <div>-->
<!--          <div class="vipstorename">中山市什么公司</div>-->
<!--          <div class="vipstoreaddress">地址：中山市</div>-->
<!--          <div class="vipstorejuli">-->
<!--            <img src="../../../static/dizhiicon.png" class="juliicon" />-->
<!--            <div>2.58千米</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    <div class="pagenonevip"></div>-->
<!--    </div>-->

  </div>
</template>

<script>
  // import marquee from '@/components/marquee/marquee.vue'
  import httper from '../../api/http';
  import {Dialog} from "vant";
  export default {

    data() {
      return {
        realData: [
          {
          url: require("../../../static/1.png"),
          name:"用户C****Y已购买",
          id:1
        }, {
          url: require("../../../static/2.png"),
          name:"用户C****Y已购买",
          id:2
        }, {
          url: require("../../../static/3.png"),
          name:"用户C****Y已购买",
          id:3
        }, {
          url: require("../../../static/4.png"),
          name:"用户C****Y已购买",
          id:4
        }, {
          url: require("../../../static/5.png"),
          name:"用户C****Y已购买",
          id:5
        }, {
          url: require("../../../static/6.png"),
          name:"用户C****Y已购买",
          id:6
        },{
          url: require("../../../static/7.png"),
          name:"用户C****Y已购买",
          id:7
        }, {
          url: require("../../../static/8.png"),
          name:"用户C****Y已购买",
          id:8
        }, {
          url: require("../../../static/9.png"),
          name:"用户C****Y已购买",
          id:9
        }, {
          url: require("../../../static/10.png"),
          name:"用户C****Y已购买",
          id:10
        }],
        viplist: [
          {
          id: 1,
          src: require("../../../static/xicheqizhe.png"),
          name: "洗车7折"
        }, {
          id: 2,
          src: require("../../../static/dalaqizhe.png"),
          name: "打蜡7折"
        }, {
          id: 3,
          src: require("../../../static/xiaoduqizhe.png"),
          name: "消毒7折"
        }, {
          id: 4,
          src: require("../../../static/butaiqizhe.png"),
          name: "补胎7折"
        }, {
          id: 5,
          src: require("../../../static/baoyangbazhe.png"),
          name: "保养8折"
        }, {
          id: 6,
          src: require("../../../static/buqibazhe.png"),
          name: "补漆8折"
        }, {
          id: 7,
          src: require("../../../static/kongtiaoqingxi.png"),
          name: "空调清洗8折"
        }, {
          id: 8,
          src: require("../../../static/anquanjiance.png"),
          name: "安全检测"
        }, {
          id: 9,
          src: require("../../../static/daijiadaijian.png"),
          name: "代驾代检"
        }, {
          id: 10,
          src: require("../../../static/daolujiuyuan.png"),
          name: "道路救援"
        }, {
          id: 11,
          src: require("../../../static/zixunfuwu.png"),
          name: "咨询服务"
        }, {
          id: 12,
          src: require("../../../static/jingqingqidai.png"),
          name: "敬请期待"
        }],
        isback:true,
        show:false,
        isagree:false,
        status:0,
        activationpopup:false,//激活弹窗
        cardNo:"",//激活车牌
        usertype:"",//客户是否购买/激活
        buttonClicked:false,
        carddetail:{},//车主卡详情
        ccard_id:"",//车主卡id
        userInfo:{},//用户信息
      }
    },
    created() {
      if (this.$route.query.status) {
        this.status = this.$route.query.status
      }
      if (this.$route.query.ccard_id) {
        this.ccard_id = this.$route.query.ccard_id
      }
      // if(localStorage.getItem("cardNo")){
      //   this.cardNo = localStorage.getItem("cardNo")
      // }
      if(localStorage.getItem("usertype")){
        this.usertype = localStorage.getItem("usertype")
      }

      this.request("getcarddetail",{
        ccard_user_id:this.ccard_id
      })
       // this.move()
    },
    mounted() {

    },
    methods: {
      openpopup(){
        this.show=true
      },
      //全部店铺
      toservice(priductId,id){
        if(priductId){
          this.$router.push({
            path: '/offlineserverList',
            query: {
              product_id: priductId
            }
          })
        }else{
          if(id==14){
          }
        }

      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //激活
      activation(){
        if(this.isagree){
          this.activationpopup=true
        }else{
          this.$toast({
            message: '请阅读并同意《优越服务车主卡协议》',
          });
        }

      },

      //确认激活
      confirm(){
        console.log("card",this.cardNo)
        this.buttonClickedFun(3000)
        let that = this
        Dialog.confirm({
          title: '提示',
          message: '确认激活车主卡？',
        })
          .then(() => {
            that.activationpopup=false
            that.request("activecard",{
              ccard_user_id:that.ccard_id,
              car_no:that.cardNo
            })
          })
          .catch(() => {
            return false;
          });

        // localStorage.setItem("cardNo",this.cardNo)
        // localStorage.removeItem("usertype")
        // localStorage.setItem("usertype","2")

      },
      //同意协议选择框
      changeisagree(){
        this.isagree = !this.isagree
      },
      //查看说明
      tovippricacy(){
        this.$router.push({
          path:'/vipPricacy'
        })
      },
      //正反面
      slide(){
        this.isback=!this.isback
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data

              }else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
          // 车主卡激活
          case 'activecard':
            httper.post('/user/active-ccard', requestData, res => {
              if (res.code == 0) {
                this.$toast({
                  message: '激活成功！',
                });
                window.location.reload()
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
          // 车主卡详情
          case 'getcarddetail':
            httper.get('/user/ccard-user-detail', requestData, res => {
              if (res.code == 0) {
                this.carddetail = res.data
                this.request("getUserInfo")
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .vipcardpage {
    width: 100%;
    background-color: #000000;
    background-image: url(../../../static/vipbg.png);
    /*  height: 100vh; */
  /* width: 100vw;*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  //bottom: 0;
  background-size: cover;
  background-position: center center;
}

.vipcardcenter {
  width: calc(100% - 40px);
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  margin: 108px 20px 20px;
}





.vipcarddetaillist {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
  flex-wrap: wrap;
}

.vipcarddetailbox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 78px;
  margin: 10px 0;
}

.vipcarddetailicon {
  width: 33px;
  height: 33px;
  margin-bottom: 8px;
}

.vipcarddetailname {
  font-size: 13px;
  color: #748BB4;
}

.vipcardtipbox {
  width: 100%;
  margin-bottom: 10px;
  background-color: #F0F0F7;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 12px;
}

.vipcardtiptitle {
  font-size: 14px;
  font-style: italic;
  color: #373652;

}

.vipcardtipmessage {
  font-size: 12px;
  color: #373652;

}

.vipcardbotton {
  width: 100%;
  height: 38px;
  background: #FD0303;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: 5px;
  color: #FFFFFF;
  font-size: 15px;
}
.vipcardbotton1 {
  width: 100%;
  height: 38px;
  background: #F0F0F7;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: 5px;
  color: #000000;
  font-size: 15px;
}

.vipcardselectbox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

}

.vipcardcheckicon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.vipcardchecktext {
  font-size: 14px;
  color: #666666;
}

.vipcarddetaillabel {
  width: 62px;
  margin: 10px;
}

.pagenonevip {
  width: 100%;
  height: 60px;
}

.vague {
  position: relative;
  margin: 0 auto;
  font-size: 0;
  background-color: rgba(0,0,0,.3);
}
.vague .logoMove {
  overflow: hidden;
  margin: 0 auto;
}
.vague .logoMove .logo1 {
  width: 3000px;
  animation: logomove 38s linear infinite;
  display: flex;
}

.marqueebox{
  width: 173px;
  height: 46px;
  border-radius: 12px;
  margin: 5px;
  background-color: rgba(255,255,255,.5);
  display: flex;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
}
.marqueeimg{
  width: 30px;
  height: 30px;
  border-radius: 15px;
  margin-right: 5px;
}
.marqueename{
  font-size: 14px;
  color: #FFFFFF;
}

@keyframes logomove {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0%, 0, 0);
  }
}
.vague::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 200;
  width: 330px;

}
.vague::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 330px;

  background-size: 100% 100%;
}
.vipcardstorelist{
  width: 100%;
  border-radius: 12px 12px 0 0;
  padding: 20px;
  box-sizing: border-box;
  background-color: #F0F0F7;
  margin-top: 10px;
}
.vipcardstoretop{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 26px;
}
.vipcardtitle{
  font-size: 23px;
  color: #373652;
}
.vipcardstoreall{
  display: flex;
  align-items: center;
}
.vipcardstoremore{
  font-size: 15px;
  margin-right: 8px;
}
.vipcardstoreallicon{
  width: 15px;
  height: 15px;
}
.vipcardstore{
  width: 100%;
  margin-bottom: 16px;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
}
.vipstoreimg{
  width: 153px;
  height: 88px;
  margin-right: 10px;
  border-radius: 8px;
}
.vipstorename{
  font-size: 13px;
  margin-bottom: 7px;
}
.vipstoreaddress{
  font-size: 13px;
  color: #666666;
  margin-bottom: 24px;
}
.vipstorejuli{
display: flex;
align-items: center;
font-size: 13px;
color: #1EA4F9;
}
.juliicon{
width: 12px;
height: 12px;
margin-right: 5px;
}
.vipcardnone {
  width: 100%;
  height: 130px;
}
.vipcardbox {
  width: calc(100% - 40px);
  border-radius: 15px;
  position: absolute;
  top: -70px;
  background-color: #F0F0F7;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.vipcardreturn{
width: 31px;
height: 31px;
position: absolute;
top: 45%;
left: -15px;
}
.vipcardreturn1{
  width: 31px;
  height: 31px;
  position: absolute;
  top: 45%;
  right: -15px;
}
.cardbox2{
background-image: url("../../../static/cardzheng.png");
position: relative;
background-size: 100% 100%;
width: 100%;
height: 100%;
border-radius: 15px;
object-fit: cover;
}
.cardbox1{
  background-image: url("../../../static/cargbei.png");
  position: relative;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  object-fit: cover;
}
.cardtypename{
position: absolute;
top: 50.5%;
left: 6%;
font-size: 13px;
color: #373652;
font-weight: bold;
}
.cardnumber{
 position: absolute;
 top: 38%;
 left: 6%;
 font-size: 15px;
 color: #373652;
font-weight: bold;
}
.card-price{
  position: absolute;
  top: 61%;
  left: 6%;
  font-size: 15px;
  color: #373652;
  font-weight: bold;
}
.cardnumber1{
  position: absolute;
  top: 54%;
  left: 11%;
  font-size: 13px;
  color: #373652;
}
.carddaoqidate{
  position: absolute;
  top: 68%;
  left: 6%;
  font-size: 13px;
  color: #373652;
}
.quanyititle{
  font-size: 15px;
  color: #363636;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 16px;
}
.quanyidetailbox{
  width: calc(100% - 40px);
  margin: 20px;
  padding: 15px;
  box-sizing: border-box;
  background-color: #F0F0F7;
  border-radius: 12px;
}
.quanyidetailtitle{
  font-size: 15px;
  color: #373652;
  margin-bottom: 13px;
}
.quanyidetail{
font-size: 12px;
}
.activationbox{
 //width: calc(100% - 40px);
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.activationboxtitle{
  font-size: 15px;
  margin-bottom: 15px;
  text-align: center;
  font-weight: bold;
}
.activationinputbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.activationinputtext{
  font-size: 14px;
}
.activationinput{
 border: 1px solid #D2D2D2;
 border-radius: 5px;
 font-size: 14px;
 //height: 38px;
 width: calc(100% - 60px);
 padding: 8px;
 box-sizing: border-box;
}
.activationbotton{
width: 100%;
 height: 38px;
 background: #FD0303;
 border-radius: 19px;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 15px;
 color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipCard/vipCard.vue